<template>
  <v-container grid-list-lg>
    <v-layout wrap>
      <v-flex xs12 sm6 md5 class='pa-3'>
        <v-card>
          <v-card-title class='headline font-weight-regular oem-color'>
            Communications
          </v-card-title>
          <v-card-text>
            <div class='ma-3'>
              <v-select
                v-model='storeState.data.communications.type'
                :items='storeState.communicationTypeOptions'
                key='type'
                label='Communications Type'
                @change='validate()'
              ></v-select>
              <v-text-field
                v-if='bacnet()'
                v-model.number='storeState.data.communications.bacnet.baseInstance'
                key='baseInstance'
                mask='#######'
                label='Base Device Instance'
                v-validate="'required|max_value:4194302'"
                hint='0 - 4194302'
                data-vv-name="instance"
                @change='validate()'
                :error-messages="errors.collect('instance')"
                class='pt-4'
              ></v-text-field>
              <!-- BACnet general configuration -->
              <!-- <v-text-field
                v-if='bacnet()'
                v-model='storeState.data.communications.bacnet.baseName'
                key='name'
                label='Base Device Name'
                v-validate="'required'"
                hint='Only first 20 characters visible on LCD'
                counter
                maxlength="80"
                data-vv-name="name"
                @change='validate()'
                :error-messages="errors.collect('name')"
                class='pt-4'
              ></v-text-field> -->
              <v-text-field
                v-if='bacnet()'
                v-model.number='storeState.data.communications.bacnet.network'
                mask='######'
                key='network'
                label='Virtual Network #'
                v-validate="'required|min_value:1|max_value:65534'"
                hint='1 - 65534'
                data-vv-name="network"
                @change='validate()'
                :error-messages="errors.collect('network')"
                class='pt-4'
              ></v-text-field>
              <!-- BACnet IP configuration -->
              <v-text-field
                v-if='this.storeState.data.communications.type === "bac_ip"'
                v-model.number='storeState.data.communications.bacnet.port'
                mask='######'
                key='bacPort'
                label='UDP port'
                v-validate="'required|min_value:1|max_value:65534'"
                hint='1 - 65534'
                data-vv-name="UDP port"
                @change='validate()'
                :error-messages="errors.collect('UDP port')"
                class='pt-4'
              ></v-text-field>
              <v-text-field
                v-if='this.storeState.data.communications.type === "bac_ip"'
                v-model='storeState.data.communications.bacnet.bbmdAddress'
                label='BBMD Address'
                key='bbmdAddr'
                v-validate="'required|ip'"
                data-vv-name="BBMD Address"
                @change='validate()'
                :error-messages="errors.collect('BBMD Address')"
                class='pt-4'
              ></v-text-field>
              <v-text-field
                v-if='this.storeState.data.communications.type === "bac_ip"'
                v-model.number='storeState.data.communications.bacnet.bbmdTtl'
                mask='#####'
                label='BBMD TTL'
                key='bbmdTTL'
                v-validate="'required|min_value:1|max_value:28800'"
                hint='1 - 28800'
                data-vv-name="BBMD TTL"
                @change='validate()'
                :error-messages="errors.collect('BBMD TTL')"
                class='pt-4'
              ></v-text-field>
              <!-- BACnet MS/TP configuration -->
              <v-select
                v-if='this.storeState.data.communications.type === "bac_mstp"'
                v-model='storeState.data.communications.bacnet.baudrate'
                :items='baudrateOptions'
                label='Baudrate'
                key='bac_baud'
                @change='validate()'
                class='pt-4'
              ></v-select>
              <v-text-field
                v-if='this.storeState.data.communications.type === "bac_mstp"'
                v-model.number='storeState.data.communications.bacnet.macAddress'
                mask='######'
                key='bac_mac'
                label='MAC Address'
                v-validate="'required|max_value:127'"
                hint='0 - 127'
                data-vv-name="MAC Address"
                @change='validate()'
                :error-messages="errors.collect('MAC Address')"
                class='pt-4'
              ></v-text-field>
              <v-text-field
                v-if='this.storeState.data.communications.type === "bac_mstp"'
                v-model.number='storeState.data.communications.bacnet.maxMaster'
                mask='######'
                label='Max Master'
                key='bac_master'
                v-validate="`required|max_value:127|min_value:${Math.min(127,storeState.data.communications.bacnet.macAddress + 1)}`"
                :hint="storeState.data.communications.bacnet.macAddress === 127 ? 'The value is at the max of the range' : `${(storeState.data.communications.bacnet.macAddress + 1)} - 127`"
                data-vv-name="Max Master"
                @change='validate()'
                :error-messages="errors.collect('Max Master')"
                class='pt-4'
              ></v-text-field>
              <v-text-field
                v-if='this.storeState.data.communications.type === "bac_mstp"'
                v-model.number='storeState.data.communications.bacnet.maxInfoFrames'
                mask='######'
                key='info'
                label='Max Info Frames'
                v-validate="'required|max_value:100|min_value:1'"
                hint='1 - 100'
                data-vv-name="Max Info Frames"
                @change='validate()'
                :error-messages="errors.collect('Max Info Frames')"
                class='pt-4'
              ></v-text-field>
              <!-- Modbus TCP configuration -->
              <v-text-field
                v-if='this.storeState.data.communications.type === "mb_tcp"'
                v-model.number='storeState.data.communications.modbus.port'
                mask='######'
                key='mod_port'
                label='TCP port'
                v-validate="'required|min_value:1|max_value:65534'"
                hint='1 - 65534'
                data-vv-name="TCP port"
                @change='validate()'
                :error-messages="errors.collect('TCP port')"
                class='pt-4'
              ></v-text-field>
              <!-- Modbus RTU configuration -->
              <v-select
                v-if='this.storeState.data.communications.type === "mb_rtu"'
                v-model='storeState.data.communications.modbus.baudrate'
                :items='baudrateOptions'
                label='Baudrate'
                key='mod_baud'
                @change='validate()'
                class='pt-4'
              ></v-select>
              <v-select
                v-if='this.storeState.data.communications.type === "mb_rtu"'
                v-model='storeState.data.communications.modbus.parity'
                :items='storeState.parityOptions'
                label='Parity'
                key='mod_parity'
                @change='validate()'
                class='pt-4'
              ></v-select>
              <v-text-field
                v-if='this.storeState.data.communications.type === "mb_rtu"'
                v-model.number='storeState.data.communications.modbus.address'
                mask='###'
                key='mod_addr'
                label='Node Address'
                v-validate="'required|min_value:1|max_value:247'"
                hint='1 - 247'
                data-vv-name="Node Address"
                @change='validate()'
                :error-messages="errors.collect('Node Address')"
                class='pt-4'
              ></v-text-field>
              <v-label v-if='bacnet()'>
                <a :href='downloadPath + "Setra Power Meter BACnet Objects List.pdf"' download='Setra Power Meter BACnet Objects List.pdf'>
                <img :src='pdf'>BACnet Objects List</a>
              </v-label>
              <v-label v-if='modbus()'>
                <a :href='downloadPath + "Setra Power Meter Modbus Register List.pdf"' download='Setra Power Meter Modbus Register List.pdf'>
                <img :src='pdf'>Modbus Register List</a>
              </v-label>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md5 class='pa-3'>
        <v-card>
          <v-card-title class='headline font-weight-regular oem-color'>
            Network Settings
          </v-card-title>
          <v-card-text>
            <div class='ma-3'>
              <v-radio-group
                v-model='storeState.data.ethernet.dhcp' row
                class='oem-text-color'
                @change='validate()'
              >
                <v-radio label='DHCP' :value='true'></v-radio>
                <v-radio label='Static' :value='false'></v-radio>
              </v-radio-group>
              <v-text-field
                v-model='storeState.data.ethernet.macAddress'
                v-validate="'required|mac'"
                data-vv-name="mac"
                @change='validate()'
                :error-messages="errors.collect('mac')"
                maxlength='17'
                label='MAC Address'
                required
                class='pt-4'
                :readonly="true"
              ></v-text-field>
              <v-text-field
                v-model='storeState.data.ethernet.ipAddress'
                v-validate="'required|ip'"
                data-vv-name="ip"
                @change='validate()'
                :error-messages="errors.collect('ip')"
                maxlength='17'
                label='IP Address'
                required
                class='pt-4'
              ></v-text-field>
              <v-text-field
                v-model='storeState.data.ethernet.gatewayAddress'
                v-validate="'required|ip'"
                data-vv-name="gateway"
                @change='validate()'
                :error-messages="errors.collect('gateway')"
                maxlength='17'
                label='Gateway Address'
                required
                class='pt-4'
              ></v-text-field>
              <v-text-field
                v-model='storeState.data.ethernet.subnetMask'
                v-validate="'required|ip'"
                data-vv-name="subnet"
                @change='validate()'
                :error-messages="errors.collect('subnet')"
                maxlength='17'
                label='Subnet Mask'
                required
                class='pt-4'
              ></v-text-field>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import { Validator } from 'vee-validate';
import Vue from 'vue';
import * as ajax from '../ajax';

const pdfIcon = require('../assets/img/PDF_24.png');

const macRegexp = /^(([A-Fa-f0-9]{2}[:]){5}[A-Fa-f0-9]{2}[,]?)+$/i;

Validator.extend('mac', {
  getMessage: 'The MAC address is not valid.',
  validate(value) {
    return macRegexp.test(value);
  },
});

export default {
  name: 'Communications',
  components: {
    // deviceImage,
  },

  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
      storeState: this.$store.state,
      baudrateOptions: [9600, 19200, 38400, 57600, 76800],
      pdf: pdfIcon,
      downloadPath: `${ajax.baseWebUrl()}downloads/`,
    };
  },
  methods: {
    validate() {
      Vue.nextTick().then(() => {
        this.errors.clear();
        this.$validator.validateAll()
          .then((isValid) => {
            this.storeState.communicationsValid = isValid;
          });
        this.storeState.communicationsDirty = true;
      });
    },
    bacnet() {
      if (this.storeState.data.communications.type === 'bac_ip'
        || this.storeState.data.communications.type === 'bac_mstp') {
        return true;
      }
      return false;
    },
    modbus() {
      if (this.storeState.data.communications.type === 'mb_tcp'
        || this.storeState.data.communications.type === 'mb_rtu') {
        return true;
      }
      return false;
    },
    ethernet() {
      if (this.storeState.data.communications.type === 'bac_ip'
        || this.storeState.data.communications.type === 'mb_tcp') {
        return true;
      }
      return false;
    },
    serial() {
      if (this.storeState.data.communications.type === 'bac_mstp'
        || this.storeState.data.communications.type === 'mb_rtu') {
        return true;
      }
      return false;
    },
  },

};
</script>
